import * as downloaderActions from '../actions';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openInNewTab } from '../../../../general/utils/download';
import { Import } from '@myua/icons/dist/bulk24';
import { getEnabled } from '../selectors';
import { GoogleDrive } from '../../icons/GoogleDrive';
import { ToolbarButton } from '../../toolbarButton';

export const DownloadButton: React.FC<{ onMouseEnter?: () => void; onMouseLeave?: () => void }> = ({
  onMouseEnter,
  onMouseLeave,
}) => {
  const enabled = useSelector(getEnabled);
  const d = useDispatch();
  return (
    <ToolbarButton
      disabled={!enabled}
      onClick={() => d(downloaderActions.downloadButtonClicked())}
      className="ch-downloader"
      id="ch-downloader__download-button"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      icon={<Import />}
    />
  );
};

export const GDButton: React.FC<
  React.ButtonHTMLAttributes<HTMLButtonElement> & { url: string | null }
> = (props) => {
  const { onClick, disabled, ...rest } = props;

  return (
    <button
      onClick={(e) => {
        if (props.url) {
          openInNewTab(props.url);
        }
        onClick?.(e);
      }}
      id="ch-downloader__download-button-gd"
      disabled={props.url === null || disabled === true}
      {...rest}
    >
      <GoogleDrive />
    </button>
  );
};

/**
 * Тулбарный вариант кнопки Google Drive. Логика открытия ссылки та же, что
 * в GDButton, но сам GDButton остаётся «сырой» кнопкой: его вторым
 * потребителем является полноэкранный просмотрщик со своими классами.
 */
export const DownloadButtonGoogleDrive: React.FC<{
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  url: string | null;
}> = ({ onMouseEnter, onMouseLeave, url }) => {
  return (
    <ToolbarButton
      disabled={url === null}
      onClick={() => {
        if (url) openInNewTab(url);
      }}
      className="ch-downloader"
      id="ch-downloader__download-button-gd"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      icon={<GoogleDrive />}
    />
  );
};
